import { render, staticRenderFns } from "./UserAuthorizationForm.vue?vue&type=template&id=7a7c4ee8&scoped=true&"
import script from "./UserAuthorizationForm.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationForm.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthorizationForm.vue?vue&type=style&index=0&id=7a7c4ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c4ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7c4ee8')) {
      api.createRecord('7a7c4ee8', component.options)
    } else {
      api.reload('7a7c4ee8', component.options)
    }
    module.hot.accept("./UserAuthorizationForm.vue?vue&type=template&id=7a7c4ee8&scoped=true&", function () {
      api.rerender('7a7c4ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/UserAuthorization/components/common/UserAuthorizationForm.vue"
export default component.exports